import {createRouter, createWebHistory} from 'vue-router';
import LoginDialog from '@/views/authentication/LoginDialog.vue';
import ReportLanding from '@/views/header/ReportLanding.vue';
import AdminLanding from '@/views/header/AdminLanding.vue';
import AcceptLanding from '@/views/header/AcceptLanding.vue';
import TabKpisMijlpalen from '@/views/admin/TabKpisMijlpalen.vue';
import TabGebruikers from '@/views/shared/TabGebruikers.vue';
import TabInstellingen from '@/views/admin/TabInstellingen.vue';
import TabThemas from '@/views/admin/TabThemas.vue';
import PasswordResetDialog from '@/views/authentication/PasswordResetDialog.vue';
import TabBeheerAdmin from '@/views/admin/TabBeheerAdmin.vue';
import TabReportItems from '@/views/admin/TabReportItems.vue';
import TabVecozo from '@/views/admin/TabVecozo.vue';
import TabAltView from '@/views/admin/TabAltView.vue';
import {meHasPermission} from '@/base/me.js';
import TabRapporteren from '@/views/reporter/TabRapporteren.vue';
import TabBeheerReporter from '@/views/reporter/TabBeheerReporter.vue';
import TabTeDoen from '@/views/acceptant/TabTeDoen.vue';
import TabGeaccepteerd from '@/views/acceptant/TabGeaccepteerd.vue';
import TabAfgewezen from '@/views/acceptant/TabAfgewezen.vue';
import { Permission, Role } from 'common';
import ReporterManagerLanding from '@/views/header/ReporterManagerLanding.vue';
 
export enum KpiSelectEnum {
    onlyMilestones,
    allOthers
}

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes : [
        {
            path     : '/',
            name     : 'login',
            component: LoginDialog,
        },
        {
            path     : '/auth/reset-password',
            name     : 'password reset',
            component: PasswordResetDialog,
        },
        {
            path     : '/admin',
            name     : 'admin',
            component: AdminLanding,
            meta     : {requires: 'admin'},
            redirect : () => getStoredTab('admin', '/admin/thema'),
            children : [
                {
                    path     : 'thema',
                    component: TabThemas,
                    meta     : {requires: 'admin'},
                },
                {
                    path     : 'organization',
                    component: TabInstellingen,
                    meta     : {requires: 'admin'},
                },
                {
                    path     : 'user',
                    component: TabGebruikers,
                    meta     : {requires: 'admin'},
                },
                {
                    path     : 'milestone',
                    component: TabKpisMijlpalen,
                    props    : {kpiSelect: KpiSelectEnum.onlyMilestones},
                    meta     : {requires: 'admin'},
                },
                {
                    path     : 'kpi',
                    component: TabKpisMijlpalen,
                    props    : {kpiSelect: KpiSelectEnum.allOthers},
                    meta     : {requires: 'admin'},
                },
                {
                    path     : 'status',
                    component: TabReportItems,
                    meta     : {requires: 'admin'},
                },
                {
                    path     : 'altview',
                    component: TabAltView,
                    meta     : {requires: 'admin'},
                },
                {
                    path     : 'vecozo',
                    component: TabVecozo,
                    meta     : {requires: 'admin'},
                },
                {
                    path     : 'admin',
                    component: TabBeheerAdmin,
                    meta     : {requires: 'admin'},
                },
            ],
        },
        {
            path     : '/report',
            name     : 'report',
            component: ReportLanding,
            meta     : {requires: 'report'},
            redirect : () => getStoredTab('report', '/report/rapporteren'),
            children : [
                {
                    path     : 'rapporteren',
                    component: TabRapporteren,
                    meta     : {requires: 'report'},
                },
                {
                    path     : 'beheer',
                    component: TabBeheerReporter,
                    meta     : {requires: 'report'},
                },
            ],
        },
        {
            path     : '/accept',
            name     : 'accept',
            component: AcceptLanding,
            meta     : {requires: 'accept'},
            redirect : () => getStoredTab('accept', '/accept/te-doen'),
            children : [
                {
                    path     : 'te-doen',
                    component: TabTeDoen,
                    meta     : {requires: 'accept'},
                },
                {
                    path     : 'geaccepteerd',
                    component: TabGeaccepteerd,
                    meta     : {requires: 'accept'},
                },
                {
                    path     : 'afgewezen',
                    component: TabAfgewezen,
                    meta     : {requires: 'accept'},
                },
            ],
        },
        {
            path     : '/report_manager',
            name     : 'report manager',
            component: ReporterManagerLanding,
            meta     : {requires: Permission.manage_reporters},
            redirect : () => getStoredTab('report manager', '/report_manager/user'),
            children : [
                {
                    path     : 'user',
                    component: TabGebruikers,
                    meta     : { requires: Permission.manage_reporters },
                    props    : { selectableRoles: [Role.reporter] }
                    
                }
            ],
        },
        {
            path    : '/:pathMatch(.*)*',
            redirect: '/',
        },
    ],
});

function getStoredTab(perm: string, def: string): string {
    const stored: string | null = localStorage.getItem(`activeTab:${perm}`);
    if (stored) {
        const hasComponent: boolean = router.resolve(stored).matched.some(
            (r: any) => r.components && Object.keys(r.components).length > 0
        );
        if (hasComponent) {
            return stored;
        }
        localStorage.removeItem(`activeTab:${perm}`);
    }
    return def;
}

router.beforeEach(async function (to: any, _from: any, next: any) {
    const perm = to.meta.requires;
    if (!perm) {
        next();
    } else if (!await meHasPermission(perm)) {
        next('/');
    } else {
        if (to.path !== '/') {
            localStorage.setItem(`activeTab:${perm}`, to.path);
        }
        next();
    }
});

export default router;
